module.exports = __webpack_public_path__ + "static/media/cs_Just_Figures.12e7496f.png";